// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: HardshipDeclarationDetails
// ====================================================

export interface HardshipDeclarationDetails {
  /**
   * The user's existing eviction case index number, if any.
   */
  indexNumber: string;
  /**
   * The court the user's existing eviction case is at, if any.
   */
  courtName: string;
  /**
   * Whether the user has COVID-19 related financial hardship.
   */
  hasFinancialHardship: boolean;
  /**
   * Whether the user has COVID-19 related heath risk.
   */
  hasHealthRisk: boolean;
}

export const BlankHardshipDeclarationDetails: HardshipDeclarationDetails = {
  "indexNumber": "",
  "courtName": "",
  "hasFinancialHardship": false,
  "hasHealthRisk": false
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment HardshipDeclarationDetails on HardshipDeclarationDetailsType {
  indexNumber,
  courtName,
  hasFinancialHardship,
  hasHealthRisk
}`;